<template>
  <router-view/>
</template>

<style lang="scss">
@import url('@/assets/css/reset.scss');
</style>
